import type { ReactNode } from "react";
import type { SectionState } from "../navigation";

export type OrganizationSectionMeta<SectionId extends string = string> = {
  id: SectionId;
  title: string;
  blurb?: string;
  icon: ReactNode;
  overviewLabel?: string;
  detailLabel?: string;
};

export type OrganizationSectionCardData<SectionId extends string = string> = {
  id: SectionId;
  state: SectionState;
  statusText: string;
};

export function OrganizationSectionIcon({
  icon,
  size = 17,
  strokeWidth = 1.8,
}: {
  icon: ReactNode;
  size?: number;
  strokeWidth?: number;
}) {
  return (
    <svg
      aria-hidden="true"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {icon}
    </svg>
  );
}
